import React from 'react'
import Background from 'components/Background'

const LoginViewBackground = () => (
  <Background height="38vh" />
)
export default LoginViewBackground
